// src/stripePlanos.js
//
// Fonte única dos planos de assinatura (price IDs, links, preços exibidos).
// Usado tanto no cadastro (FormCadastro.js, plano NOVO via
// createCheckoutSession) quanto na página de gerenciamento de assinatura
// do ADM (PaginaUsuario.js, TROCA de plano via trocarAssinatura).
//
// Os price IDs e links de checkout vêm de variáveis de ambiente do CRA
// (REACT_APP_*), não hardcoded: no build de PRODUÇÃO (react-scripts build
// sempre roda com NODE_ENV=production) um valor fixo condicionado a
// `NODE_ENV === 'development'` viraria string vazia e o Stripe Checkout
// nunca abriria — por isso os dois .env por ambiente:
//   .env.development -> usado em `npm start`     (price IDs de TESTE)
//   .env.production   -> usado em `npm run build` (price IDs de PRODUÇÃO/live)
// Nenhum dos dois é segredo: price ID e link de checkout do Stripe são
// identificadores públicos (aparecem na própria URL de pagamento), só a
// STRIPE_SECRET_KEY é sensível — e essa fica só no backend (Cloud Functions).
export const planos = [
    // {
    //   id: 'planoMensal',
    //   link: process.env.REACT_APP_STRIPE_LINK_MENSAL || '',
    //   precoId: process.env.REACT_APP_STRIPE_PRICE_MENSAL || '',
    //   nome: 'Mensal',
    //   limite: '/mês',
    //   preco: '19,99'
    // },
    // {
    //   id: 'planoDiario',
    //   link: process.env.REACT_APP_STRIPE_LINK_DIARIO || '',
    //   precoId: process.env.REACT_APP_STRIPE_PRICE_DIARIO || '',
    //   nome: 'Diario',
    //   limite: '/dia',
    //   preco: '0,50'
    // },
    {
      id: 'planoGratuito',
      link: process.env.REACT_APP_STRIPE_LINK_GRATUITO || '',
      precoId: process.env.REACT_APP_STRIPE_PRICE_GRATUITO || '',
      nome: 'Gratuito',
      limite: '',
      preco: '00,00'
    },
    // {
    //   id: 'planoTrimestral',
    //   link: process.env.REACT_APP_STRIPE_LINK_TRIMESTRAL || '',
    //   precoId: process.env.REACT_APP_STRIPE_PRICE_TRIMESTRAL || '',
    //   nome: 'Trismestral',
    //   limite: '/trimestre',
    //   preco: '54,99'
    // },
    // {
    //   id: 'planoAnual',
    //   link: process.env.REACT_APP_STRIPE_LINK_ANUAL || '',
    //   precoId: process.env.REACT_APP_STRIPE_PRICE_ANUAL || '',
    //   nome: 'Anual',
    //   limite: '/ano',
    //   preco: '199,99'
    // }
];
